export const groupClasses = [
  {
    "id": "sculpt-tone",
    "name": "Sculpt & Tone",
    "focus": "Strength & control",
    "coach": "Annette",
    "description": "Make time for focused strength work in an encouraging group setting. Build your routine around purposeful movement and attentive coaching.",
    "sessions": [
      {
        "day": "Tuesday",
        "time": "8:30–9:30 AM"
      }
    ]
  },
  {
    "id": "yoga",
    "name": "Yoga",
    "focus": "Movement & mindfulness",
    "coach": "Jodi",
    "description": "Set aside time to move, breathe, and reconnect with your body. Explore yoga in a welcoming space where you can talk with your instructor about your needs.",
    "sessions": [
      {
        "day": "Tuesday",
        "time": "9:30–10:30 AM"
      },
      {
        "day": "Thursday",
        "time": "9:30–10:30 AM"
      }
    ]
  },
  {
    "id": "quickies",
    "name": "Quickies",
    "focus": "Your evening workout",
    "coach": "Annette",
    "description": "Bring some energy to your evening with a coached group workout. Connect with your instructor to learn about the class format and find the right starting point for you.",
    "sessions": [
      {
        "day": "Tuesday",
        "time": "5:30–6:30 PM"
      },
      {
        "day": "Thursday",
        "time": "5:30–6:30 PM"
      }
    ]
  },
  {
    "id": "zumba",
    "name": "Zumba",
    "focus": "Dance & movement",
    "coach": "Gisel",
    "description": "Enjoy movement with music and the encouragement of a group. Make your workout something to look forward to, and ask your instructor how to approach your first class.",
    "sessions": [
      {
        "day": "Wednesday",
        "time": "4–5 PM"
      }
    ]
  },
  {
    "id": "cardio-meditation",
    "name": "Cardio Meditation",
    "focus": "Movement & focus",
    "coach": "Patti",
    "description": "Give yourself time for movement and mindful focus. Talk with Patti about how the class brings cardio and meditation together and what to expect in your first session.",
    "sessions": [
      {
        "day": "Wednesday",
        "time": "6–7 PM"
      },
      {
        "day": "Thursday",
        "time": "7–8 PM"
      },
      {
        "day": "Friday",
        "time": "6–7 PM"
      },
      {
        "day": "Saturday",
        "time": "10–11 AM"
      }
    ]
  },
  {
    "id": "tab-core",
    "name": "Tab & Core",
    "focus": "Core-focused training",
    "coach": "Annette",
    "description": "Explore core-focused training with the motivation of a group. Your instructor can explain the workout format and help you choose an appropriate approach for your needs.",
    "sessions": [
      {
        "day": "Thursday",
        "time": "8:30–9:30 AM"
      }
    ]
  },
  {
    "id": "stretching-mobility",
    "name": "Stretching & Mobility",
    "focus": "Move with confidence",
    "coach": "Gisel",
    "description": "Give your body dedicated time for stretching and mobility work. Share your movement goals with your instructor and explore a class focused on moving with greater ease.",
    "sessions": [
      {
        "day": "Friday",
        "time": "7–8 AM"
      }
    ]
  },
  {
    "id": "step",
    "name": "Step",
    "focus": "Rhythm & movement",
    "coach": "Kamryn",
    "description": "Add a step-based workout to your week in a supportive group setting. Check in with Kameryn about the class format, pacing, and what you need for your first visit.",
    "sessions": [
      {
        "day": "Friday",
        "time": "9–10 AM"
      }
    ]
  },
  {
    "id": "circuit-training",
    "name": "Circuit Training",
    "focus": "Variety & consistency",
    "coach": "Reyna",
    "description": "Start your weekend with the variety of circuit training and the encouragement of a group. Ask Reyna about the exercises and how to approach the session at your starting point.",
    "sessions": [
      {
        "day": "Saturday",
        "time": "8:30–9:30 AM"
      }
    ]
  }
]
